
import { useState } from "react";
import { generateUUID } from "@/lib/utils/uuid";
import NotificationsContent, { Notification } from "../../notifications/NotificationsContent";

const NotificationsTab = () => {
  const [notifications, setNotifications] = useState<Notification[]>([
    { 
      id: generateUUID(),
      title: "New inquiry received", 
      description: "You have received a new inquiry for Seaside Luxury Villa", 
      time: "2 hours ago",
      type: "inquiry",
      read: false
    },
    { 
      id: generateUUID(),
      title: "Featured status expiring", 
      description: "Your featured status for Downtown Apartment expires in 3 days", 
      time: "1 day ago",
      type: "featured",
      read: false
    },
    { 
      id: generateUUID(),
      title: "Boost activated", 
      description: "Your listing boost for Mountain Retreat is now active", 
      time: "3 days ago",
      type: "boost",
      read: true
    },
    { 
      id: generateUUID(),
      title: "Profile updated", 
      description: "Your profile information has been successfully updated", 
      time: "5 days ago",
      type: "system",
      read: true
    },
  ]);

  const handleMarkAsRead = (id: string) => {
    setNotifications(notifications.map(notification => 
      notification.id === id ? { ...notification, read: true } : notification
    ));
  };

  const handleMarkAllAsRead = () => {
    setNotifications(notifications.map(notification => ({ ...notification, read: true })));
  };

  return (
    <NotificationsContent 
      notifications={notifications}
      onMarkAsRead={handleMarkAsRead}
      onMarkAllAsRead={handleMarkAllAsRead}
    />
  );
};

export default NotificationsTab;
